import { render } from "./VideoSection.vue?vue&type=template&id=373d71c5&scoped=true"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"

import "./VideoSection.vue?vue&type=style&index=0&id=373d71c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373d71c5"]])

export default __exports__